// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bpxebrbhhywoayvqwdnh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJweGVicmJoaHl3b2F5dnF3ZG5oIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ3OTQwNzUsImV4cCI6MjA2MDM3MDA3NX0.aMoMxNwfxI0MuSKxgYri4y1Xrf9tJtTflKAAyZzRRbE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Session token management for custom auth.
// We read the token PER REQUEST directly from localStorage so the header
// stays in sync with whatever the auth layer last wrote, regardless of
// whether updateSupabaseSessionToken() was called on every code path.
const readSessionToken = (): string | null => {
  if (typeof window === 'undefined') return null;
  try {
    return localStorage.getItem('auth_session_token');
  } catch {
    return null;
  }
};

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    fetch: (url: RequestInfo | URL, options: RequestInit = {}) => {
      const token = readSessionToken();
      if (token) {
        const headers = new Headers(options.headers);
        headers.set('x-session-token', token);
        return fetch(url, { ...options, headers });
      }
      return fetch(url, options);
    },
  },
});

/**
 * Kept for backwards compatibility. The fetch wrapper now reads the
 * session token fresh from localStorage on every request, so this is a
 * no-op. Existing callers can keep invoking it without harm.
 */
export const updateSupabaseSessionToken = (token: string | null) => {
  console.log("[supabase-client] updateSupabaseSessionToken called (no-op):", token ? `${token.slice(0, 12)}...` : 'cleared');
};
